import { ReactNode } from 'react';
import BgNsCard from '@britishgasenergy/react-nucleus/dist/nuc-components/NsCard';

export type NsCardProps = {
  testId?: string;
  type?: 'standard' | 'support' | 'flat';
  pillOverImage?: boolean;
  decoration?:
    | 'appliance'
    | 'applianceCover'
    | 'applianceRepair'
    | 'battery'
    | 'boiler'
    | 'boilerCover'
    | 'boilerRepair'
    | 'bulb'
    | 'calendar'
    | 'centralHeating'
    | 'chat'
    | 'clock'
    | 'compass'
    | 'cosmo'
    | 'document'
    | 'dualFuel'
    | 'electrics'
    | 'electricChargingStation'
    | 'electricVehicle'
    | 'engineer'
    | 'engineer-long-hair'
    | 'fix'
    | 'fixedSA'
    | 'gas'
    | 'greenLeaf'
    | 'help'
    | 'home'
    | 'homeInsurance'
    | 'laptop'
    | 'lowCarbon'
    | 'multiplePeople'
    | 'oven'
    | 'phone'
    | 'pipeAndDrain'
    | 'protect'
    | 'payments'
    | 'radiator'
    | 'savings'
    | 'settings'
    | 'sms'
    | 'tap'
    | 'trackEngineer'
    | 'van'
    | 'whatsApp'
    | 'yellowShield'
    | 'warning'
    | 'error'
    | 'success'
    | 'info'
    | 'home-insurance'
    | 'green-leaf'
    | 'rosette-tick-green'
    | 'homeSolarPanelGreen'
    | 'barGraph'
    | 'boiler-repair';
  image?: string;
  alt?: string;
  heading?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
};

export const NsCard = ({
  type = 'standard',
  pillOverImage = false,
  decoration,
  image,
  alt,
  heading,
  action,
  children,
  testId
}: NsCardProps) => {
  const actionSlot = type === 'standard' ? 'cta' : 'action';
  return (
    <BgNsCard
      data-testid={testId}
      type={type}
      pillOverImage={pillOverImage}
      decoration={decoration}
      alt={alt}
      image={image}
    >
      {heading && <h3 slot="heading">{heading}</h3>}
      {children && <div slot="paragraph">{children}</div>}
      {action && <div slot={actionSlot}>{action}</div>}
    </BgNsCard>
  );
};
